// Saringan bersama layar daftar purchasing (pola daftar seragam, 28 Sep 2026;
// `docs/POLA_DAFTAR.md`).
//
// "Belum selesai" adalah SATU pilihan di kotak Status, bukan status sungguhan: layar
// mengirim `belum_selesai=true` dan BACKEND yang menentukan status mana yang selesai
// (diturunkan dari tone daur hidup `done`/`void`; PR dari tiga status akhirnya).
// Layar tidak pernah menyalin daftar status akhir — status baru di backend ikut sendiri.
import { isoPlusDays, formatDate } from "./format";

export const BELUM_SELESAI = "BELUM_SELESAI";

/** Saringan `status` (nilai kode atau BELUM_SELESAI) → parameter server. Murni. */
export function paramStatus(paramSaringan) {
  const { status, ...lain } = paramSaringan || {};
  if (!status) return lain;
  return status === BELUM_SELESAI ? { ...lain, belum_selesai: true } : { ...lain, status };
}

/** Definisi saringan status untuk `useDaftar`, bawaan "Belum selesai". */
export function saringanStatus(meta, { bawaan = BELUM_SELESAI, labelBelum = "Belum selesai" } = {}) {
  return {
    label: "Status",
    bawaan,
    tampil: (v) => (v === BELUM_SELESAI
      ? labelBelum
      : (meta?.statuses || []).find((s) => s.code === v)?.label || v),
  };
}

/** Tanggal `n` hari lalu (YYYY-MM-DD, hari lokal) — bawaan saringan "periode terbaru". */
export const hariLalu = (n) => isoPlusDays(-n);

export const saringanDari = (bawaan = "") => ({ label: "Dari", param: "date_from", bawaan, tampil: (v) => formatDate(v) });
export const saringanSampai = () => ({ label: "Sampai", param: "date_to", tampil: (v) => formatDate(v) });
